/**
 * Versão do app — injetada pelo Vite no build.
 *
 * - __APP_VERSION__: lido de package.json (semver)
 * - __COMMIT_SHA__: hash curto do commit (git rev-parse --short HEAD)
 *   Em CI, vem da env var VITE_COMMIT_SHA injetada pelo GitHub Actions.
 * - __BUILD_DATE__: ISO timestamp do momento do build
 *
 * Esses defines são configurados em vite.config.ts.
 */

declare const __APP_VERSION__: string;
declare const __COMMIT_SHA__: string;
import { formatDate } from './lib/format-date';

declare const __BUILD_DATE__: string;

export const VERSION = __APP_VERSION__;
export const COMMIT_SHA = __COMMIT_SHA__;
export const BUILD_DATE = __BUILD_DATE__;

/** String formatada pra exibir no rodapé. Ex: "v0.1.0 · 5e2d8a" */
export const VERSION_LABEL = `v${VERSION} · ${COMMIT_SHA}`;

/** String completa com data, útil pra debug. */
export const VERSION_FULL = `${VERSION_LABEL} · ${formatDate(BUILD_DATE)}`;
